import React, { Component } from 'react';
import { connect } from 'react-redux'
import styled from 'styled-components';
import qs from "qs";
import validator from "validator";

import {setGiftAmount, setGiftRecipient} from '../Actions'
import Centered from "../Components/Centered";
import CalloutSection from "../Components/CalloutSection";
import GradientSection from "../Components/GradientSection";
import TitleText from "../Components/TitleText";
import PrimaryButton from "../Components/PrimaryButton";
import TextField from "../Components/TextField";
import {withRouter} from "react-router-dom";
import ParagraphText from "../Components/ParagraphText";
import TextSection from "../Components/TextSection";
import TopContent from "../Components/TopContent";
import HowItWorksSteps from "../Containers/HowItWorksSteps";
import MenuButton from "../Components/MenuButton";
import SplitSection from "../Components/SplitSection";


const BlockchainLogo = styled.img`
  height: 30px;
  margin-right: 1em;
  
  @media (max-width: 400px) {
    height: 25px;
  }
`;

const CoinbaseLogo = styled.img`
  height: 38px;
  margin-left: 1em;
  @media (max-width: 400px) {
    height: 32px;
  }
`;

const TopShieldImg = styled.div`
  margin-left: 1em;
  margin-right: 1em;
  width: 100%;
  height: 100%;
  background: url('./shield.png') no-repeat center 30%;
  background-size: contain;
  min-height: 100px;
  display: none;
  
  @media (max-width: 800px) {
    display: block; 
  } 
`;

const RightShieldImg = styled.div`
  margin-left: 1em;
  margin-right: 1em;
  width: 100%;
  height: 100%;
  background: url('./shield.png') no-repeat center 30%;
  background-size: contain;
  display: block;
  
  @media (max-width: 800px) {
    display: none; 
  } 
`;

const InlineSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const RequestButton = styled(MenuButton)`
  position: relative;
`;

class RecipientPage extends Component {
  componentDidMount() {
    if(this.props.wallet.address) {
      return this.props.history.push('/verify');
    }
    if(this.props.location.search) {
      const query =  qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
      if(query && query.btc && parseFloat(query.btc)) {
        const giftAmount = parseFloat(query.btc);
        this.props.dispatch(setGiftAmount({
          giftAmount,
        }));
      } else if(query && query.satoshis && parseFloat(query.satoshis)) {
        const giftAmount = parseFloat(query.satoshis) / 100000000;
        this.props.dispatch(setGiftAmount({
          giftAmount,
        }));
      }
      if(query && query.recipient && validator.isEmail(query.recipient)) {
        this.props.dispatch(setGiftRecipient({
          recipientEmail: query.recipient,
        }));
      }
    }
  }
  handleKeyPress (e) {
    if (e.key === 'Enter') {
      this.onBlur(e);
    }
  }
  onBlur(event) {
    const typedRecipient = event.target.value;
    this.props.dispatch(setGiftRecipient({
      recipientEmail: typedRecipient
    }));
  }
  render() {
    return (
      <Centered>
        <TopContent>
          <CalloutSection>
            <div className="spacer-20px" />

            <div className="spacer-40px" />
            <Centered itemscope itemtype="http://schema.org/WebApplication">
              <TitleText>
                <span itemProp="name">Biterica has shut down. <br />All gifts are safe.</span>
              </TitleText>
              <div className="spacer-20px" />
              <p>All gifts received are safe and will continue to be safe! <br/>
                To access a gift received simply login  at <a href="https://blockchain.com">Blockchain.com</a><br/>
                using the same email address that received the gift: <br/>
              </p>

              <div className="spacer-20px" />
              <Centered><a className="underline" href="https://blockchain.com">Blockchain.com</a></Centered>
              <div className="spacer-40px" />
              <p>Please update your bookmarks by December 31st 2022<br/> after which this website will no longer be accessible. <br/>

              </p>

              <div className="spacer-80px" />
            </Centered>
          </CalloutSection>
        </TopContent>
        <CalloutSection>
          <TextSection>

          </TextSection>
        </CalloutSection>
        <GradientSection>
          <div className="spacer-20px" />

          <div className="spacer-20px" />
        </GradientSection>
      </Centered>
    );
  }
}

const mapStateToProps = (state) => ({
  recipientEmail: state.gift.recipientEmail,
  wallet: state.wallet
});

export default connect(mapStateToProps)(withRouter(RecipientPage));



// WEBPACK FOOTER //
// ./src/Pages/RecipientPage.js